<template>
  <div
    :class="[
      'd-flex flex-column border-bottom rounded-lg', {
        'bg-pale-danger border-danger': !isEmpty(event.extendedProps.deleted_at),
        'bg-pale-warning border-warning': isEmpty(event.extendedProps.deleted_at) && isEventUpdated
      }
    ]"
    style="z-index: 10;"
  >
    <div class="py-2 d-flex flex-column flex-md-row justify-content-between gap-4">
      <div class="d-flex align-items-center gap-2 px-2">
        <BAvatar
          :text="String(event.extendedProps.new_number_of_activities)"
          variant="outline-dark"
          size="36"
        />

        <div class="d-flex flex-column px-md-2">
          <h6
            :class="[
              'font-weight-bolder text-truncate mb-1'
            ]"
          >
            {{ event.title }}
          </h6>
          <div class="d-flex gap-2">
            <div
              v-if="event.extendedProps.province"
              class="small text-dark"
            >
              {{ isToBeHeldAt }} <b>
                {{ event.extendedProps.province?.province_name || '' }}, {{ event.extendedProps.municipality?.municipality_name || '' }}
              </b>
            </div>
          </div>
        </div>
      </div>
      <div class="px-md-2 align-self-md-center">
        <div class="d-flex justify-content-end gap-2">
          <BButton
            size="sm"
            class="min-w-65px"
            variant="primary"
            @click.prevent="$emit('view', { event, view: { type: 'listMonthEdit' } })"
          >
            {{ isPending && (isAssigned || isCreator) ? 'Process' : 'View' }}
          </BButton>
          <BButton
            v-if="isSameOrAfter"
            size="sm"
            class="min-w-65px"
            variant="outline-danger"
            @click.prevent="$emit('cancel', event.extendedProps)"
          >
            Cancel
          </BButton>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment'
import { isEmpty } from 'lodash'
import { mapGetters } from 'vuex'

export default {
  name: 'FSOMonthlyPlansListMonthView',

  props: {
    event: {
      type: Object,
      required: true
    }
  },

  emits: ['view', 'cancel'],

  computed: {

    ...mapGetters({
      user: 'auth/user'
    }),

    isEventUpdated () {
      const eventDetails = this.event.extendedProps

      const createdAt = moment(eventDetails.created_at)
      const updatedAt = moment(eventDetails.updated_at)

      const eventDate = moment(`${eventDetails.event_date} ${createdAt.format('HH:mm:ss')}`)

      return updatedAt.isAfter(eventDate, 'seconds') && Number(eventDetails.is_modified) === 1
    },

    isOfficer () {
      return this.user?.role === 'fso'
    },

    isAssigned () {
      const creator = Number(this.event.extendedProps.creator?.id)
      const assignee = Number(this.event.extendedProps.assignee?.id)

      return this.isOfficer && (creator !== assignee)
    },

    isCreator () {
      const creator = Number(this.event.extendedProps.creator?.id)
      const user = Number(this.user?.id)

      return this.isOfficer && (creator === user) && !this.isAssigned
    },

    isPending () {
      return this.event.extendedProps.status === 'Pending'
    },

    isSameOrAfter () {
      const eventDetails = this.event.extendedProps
      const today = moment().format('YYYY-MM-DD')

      return moment(eventDetails.event_date).isSameOrAfter(today, 'day') && isEmpty(eventDetails.deleted_at)
    },

    isToBeHeldAt () {
      const eventDate = moment(this.event.extendedProps.event_date).format('YYYY-MM-DD')
      const today = moment().format('YYYY-MM-DD')

      return moment(eventDate).isAfter(today, 'day') ? 'To be held at' : 'Held at'
    }
  },

  methods: {
    isEmpty: isEmpty
  }
}
</script>
